var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeleteCross = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f6006418-cde9-49ec-843a-e864c302c9e4",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none",
    opacity: 0,
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.641,1.646c.411-.411,1.078-.411,1.489,0l4.87,4.87L12.869,1.646c.411-.411,1.078-.411,1.489,0,.411.411.411,1.078,0,1.489l-4.87,4.87,4.87,4.87c.411.411.411,1.078,0,1.489-.411.411-1.077.411-1.489,0l-4.87-4.87-4.87,4.87c-.411.411-1.078.411-1.489,0-.411-.411-.411-1.078,0-1.489l4.87-4.87L1.641,3.135c-.411-.411-.411-1.078,0-1.489Z",
    fill: "#e1950d",
    fillRule: "evenodd",
    strokeWidth: 0
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-cross.1276157b.svg";
export { ForwardRef as ReactComponent };